import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './stores'
import './plugins/element.js'
import '@/assets/styles/structure.scss'

import '@/assets/fonts/iconfont.css' // 自定义图标
import '@/assets/fonts/lc-iconfont.css' // 自定义图标(不能与旧冲突)

// -------- customized plugin（begin） --------
import i18n from '@/helpers/i18n'
import '@/components'
// Http 请求
import VueAxiosPlugin from '@/plugins/axios'
Vue.use(VueAxiosPlugin)

import VueAuthPlugin from '@/plugins/authorization'
Vue.use(VueAuthPlugin, store)

import VueNoticePlugin from '@/plugins/notice'
Vue.use(VueNoticePlugin, store)

import VueMomentPlugin from '@/plugins/moment'
Vue.use(VueMomentPlugin)

import ToastPlugin from '@/plugins/toast'
Vue.use(ToastPlugin)
// -------- customized plugin（end） --------

// ---- third party plugin (begin) -----
import tooltip from 'v-tooltip'
Vue.use(tooltip)

import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)

import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

import vStarRating from 'vue-star-rating'
Vue.use(vStarRating)

import vResizeDirective from 'vue-resize-directive'
Vue.use(vResizeDirective)

import vImgInput from 'vue-img-inputer'
import 'vue-img-inputer/dist/index.css'
Vue.component('ImgInputer', vImgInput)

import multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.component('multiselect', multiselect)

// import moment from 'moment'
// moment.locale('zh-cn')
// Vue.use(require('vue-moment'), { moment })
// this.$moment = moment

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
// ---- third party plugin (end) -------

// -------- mixin（begin） --------
import globalMixIn from '@/mixins/global'
Vue.mixin(globalMixIn)

import identificationMixIn from '@/mixins/identification'
Vue.mixin(identificationMixIn)

import '@/mixins/date_time_filter'
// -------- mixin（end） --------

// -------  directives (begin) ------
import '@/directives/v-delete-record'
import '@/directives/v-auto-height'
import '@/directives/v-sortable'
// -------  directives (end) --------

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')

// 历史原因，建议使用 this.$moment
import moment from 'moment'
window.moment = moment // 容器被其他第三方库引用修改，不要直接应用 $moment

window.app.bus = new Vue() // 创建一条基于 App 的总线给全局使用

import './vendors/vuelidate.js'
